var _Path, _G, _Defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path, G, Rect, Circle, Mask, Defs } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: filter */
function SvgAppointmentVideo(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 96,
    height: 96,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M69.884 86.554c-23.588 13.852-52.507 7.82-64.594-13.473C-6.796 51.788 2.528 23.298 26.116 9.446 49.704-4.406 78.623 1.626 90.71 22.919c12.086 21.293 2.762 49.783-20.826 63.635z",
    fill: "#C0E9D3"
  })), _G || (_G = /*#__PURE__*/React.createElement(G, {
    filter: "url(#appointment-video_svg__filter0_d_2365_44932)"
  }, /*#__PURE__*/React.createElement(Rect, {
    x: 7.5,
    y: 17.215,
    width: 26,
    height: 48.95,
    rx: 3.4,
    fill: "#E9E2F9",
    stroke: "#2F2F2F"
  }), /*#__PURE__*/React.createElement(Rect, {
    x: 10.199,
    y: 17.215,
    width: 31.4,
    height: 48.95,
    rx: 3.4,
    fill: "#E9E2F9",
    stroke: "#2F2F2F"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M20.136 31.053c.058 4.006 2.736 7.036 5.786 6.992 3.049-.044 5.64-3.149 5.582-7.155-.057-4.006-2.736-7.035-5.785-6.992-3.05.044-5.64 3.15-5.583 7.155z",
    fill: "#fff",
    stroke: "#2F2F2F"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M15.257 48.342c4.77-8.907 13.836-10.441 21.56-.416 1.267 1.644-.012 3.89-2.088 3.89H17.54c-1.854 0-3.157-1.84-2.282-3.474z",
    fill: "#8ED7AF",
    stroke: "#2F2F2F",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M19.264 48.891l.062-.216a6.005 6.005 0 013.088-3.721v0m0 0v0a6.005 6.005 0 013.088 3.72l.062.217m-3.15-3.937v-3.15",
    stroke: "#2F2F2F",
    strokeMiterlimit: 3.869,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M30.287 48.105v-5.907",
    stroke: "#2F2F2F"
  }), /*#__PURE__*/React.createElement(Circle, {
    cx: 30.287,
    cy: 50.916,
    r: 2.65,
    fill: "#E9E2F9",
    stroke: "#2F2F2F"
  }), /*#__PURE__*/React.createElement(Circle, {
    cx: 25.899,
    cy: 61.264,
    r: 2.2,
    fill: "#E9E2F9",
    stroke: "#2F2F2F"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M88.227 69.45C77.61 50.57 54.502 47.101 35.824 68.985c-1.38 1.617-.185 4.027 1.941 4.027h48.259c1.875 0 3.122-1.93 2.203-3.564z",
    fill: "#C1D4F7",
    stroke: "#2F2F2F",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M76.278 40.156c-2.353 7.53-9.758 12.223-16.54 10.48-6.78-1.742-10.37-9.26-8.016-16.792 2.353-7.53 9.758-12.223 16.54-10.48 6.78 1.742 10.37 9.26 8.016 16.792z",
    fill: "#fff",
    stroke: "#2F2F2F"
  }), /*#__PURE__*/React.createElement(Mask, {
    id: "appointment-video_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.511 7.732c4.777 4.338 3.847 10.722-2.078 14.258-3.174 1.894-7.138 2.586-10.868 2.155a8.567 8.567 0 01-6.443 1.962 11.552 11.552 0 001.962-3.087c-1.507-.61-2.881-1.44-4.03-2.484-4.778-4.338-3.847-10.721 2.078-14.257 5.925-3.536 14.602-2.885 19.38 1.453z"
  })), /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.511 7.732c4.777 4.338 3.847 10.722-2.078 14.258-3.174 1.894-7.138 2.586-10.868 2.155a8.567 8.567 0 01-6.443 1.962 11.552 11.552 0 001.962-3.087c-1.507-.61-2.881-1.44-4.03-2.484-4.778-4.338-3.847-10.721 2.078-14.257 5.925-3.536 14.602-2.885 19.38 1.453z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M55.433 21.99l.512.858-.512-.858zM57.51 7.732l.672-.74-.672.74zM44.565 24.145l-.645-.765.33-.278.43.05-.115.992zm-6.443 1.962l-.106.995-1.926-.207 1.283-1.45.75.662zm1.962-3.087l.375-.927.949.383-.405.94-.919-.396zm-4.03-2.484l.672-.74-.672.74zM38.132 6.28l-.512-.859.512.859zM54.92 21.13c2.757-1.645 4.251-3.887 4.576-6.114.322-2.211-.484-4.571-2.657-6.545l1.344-1.48c2.605 2.365 3.722 5.365 3.292 8.314-.428 2.934-2.361 5.651-5.53 7.542l-1.025-1.717zm-10.24 2.02c3.543.41 7.28-.254 10.24-2.02l1.025 1.717c-3.388 2.022-7.578 2.743-11.495 2.29l.23-1.987zm-6.451 1.962c2 .215 4.066-.364 5.691-1.733l1.289 1.53a9.567 9.567 0 01-7.194 2.192l.214-1.99zm2.774-1.698a12.552 12.552 0 01-2.132 3.355l-1.498-1.326a10.55 10.55 0 001.793-2.82l1.837.791zm-4.277-3.619c1.051.954 2.321 1.725 3.733 2.297l-.75 1.854c-1.602-.649-3.08-1.538-4.328-2.67l1.345-1.48zm1.919-12.658c-2.757 1.645-4.251 3.886-4.576 6.113-.322 2.212.484 4.572 2.657 6.545l-1.344 1.48c-2.605-2.364-3.722-5.365-3.292-8.314.428-2.933 2.361-5.651 5.53-7.542l1.025 1.718zm18.194 1.334c-2.19-1.989-5.327-3.172-8.662-3.422-3.331-.25-6.77.44-9.532 2.088L37.62 5.42c3.163-1.888 7.025-2.64 10.707-2.365 3.679.276 7.27 1.587 9.856 3.937l-1.344 1.48z",
    fill: "#2F2F2F",
    mask: "url(#appointment-video_svg__a)"
  }), /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.715 9.31a.519.519 0 00-.518.518v2.553h-2.522a.519.519 0 00-.519.518v2.036c0 .286.232.518.519.518h2.522v2.555c0 .287.232.519.518.519h1.998a.519.519 0 00.519-.519v-2.555h2.511a.519.519 0 00.518-.518v-2.036a.519.519 0 00-.518-.518h-2.511V9.828a.519.519 0 00-.519-.518h-1.998z",
    fill: "#FF4259"
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null)));
}
export default SvgAppointmentVideo;